export default __webpack_public_path__ + "static/media/clap.eb738e52.wav";